"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeBlockOptionsPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const slate_react_1 = require("slate-react");
const context_1 = require("@jsonjoy.com/ui/lib/4-card/Popup/context");
const EditorContextPopup_1 = require("../../../chrome/EditorContextPopup");
const CodeBlockOptions_1 = require("./CodeBlockOptions");
const state_1 = require("./state");
const CodeBlockOptionsPopupBody = () => {
    const state = (0, state_1.useCodeBlockOptionsState)();
    return (React.createElement(EditorContextPopup_1.EditorContextPopup, { title: "Code block details", subtitle: "Set code block metadata and display options", minWidth: 300, 
        // noMargin
        onCancel: state.cancel, onApply: state.apply },
        React.createElement(CodeBlockOptions_1.CodeBlockOptions, null)));
};
const CodeBlockOptionsPopup = ({ element }) => {
    const editor = (0, slate_react_1.useSlateStatic)();
    const popup = (0, context_1.usePopup)();
    return (React.createElement(state_1.CodeBlockOptionsStateProvider, { editor: editor, element: element, closePopup: () => popup?.close() },
        React.createElement(CodeBlockOptionsPopupBody, null)));
};
exports.CodeBlockOptionsPopup = CodeBlockOptionsPopup;
